import React, { memo, useEffect, useState } from 'react';
import { HeadingMBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import GridContainer from 'components/Grid/GridContainer';
import ServiceCard from './ServiceCard';
import StayCurrentPortrait from '@material-ui/icons/StayCurrentPortrait';
import Cast from '@material-ui/icons/Cast';
import Phone from '@material-ui/icons/PhoneOutlined';
import GridItem from 'components/Grid/GridItem';
import { SingleStatistic } from 'utils/api/models/accounts/singleStatistic';
import { AccountsService } from 'services/accounts/accounts';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import styles from 'assets/jss/material-dashboard-pro-react/views/dashboard/dashboardStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillingAccount {
	name: string;
	id: string;
	accountId: string;
	billingName: string;
}

interface IActiveServices {
	selectedAccount: { id: string; name: string } | null;
	selectedBillingAccount: IBillingAccount | null;
}

const ActiveServices = ({ selectedAccount, selectedBillingAccount }: IActiveServices) => {
	const classes = useStyles();

	const [loadingStatistics, setLoadingStatistics] = useState(true);
	const [statistics, setStatistics] = useState<SingleStatistic[]>([]);
	const [selectedStatistic, setSelectedStatistic] = useState<SingleStatistic | null>(null);

	useEffect(() => {
		AccountsService.getStatisticsForAccounts()
			.pipe(finalize(() => setLoadingStatistics(false)))
			.subscribe(
				({ numberQuantities }) => setStatistics(numberQuantities),
				(error) => throwError(error)
			);
	}, []);

	useEffect(() => {
		if (selectedAccount && selectedBillingAccount && statistics && statistics.length > 0) {
			const searchedStatistics = statistics.find(
				(statistic) =>
					statistic.upAccountId === selectedAccount.id && statistic.accountId === selectedBillingAccount.id
			);
			setSelectedStatistic(searchedStatistics ?? null);
		}
	}, [statistics, selectedAccount, selectedBillingAccount]);

	return (
		<ConditionalRender
			show={!!selectedStatistic && !loadingStatistics}
			onTrue={() => (
				<GridItem xs={12} id="dashboard-active-services">
					<HeadingMBold color="secondary-light" disableMargin>
						{translate('dashboard.active.services')}
					</HeadingMBold>
					<GridContainer className={classes.servicesContainer}>
						<ServiceCard
							text={translate('numbers.mobile-prepaid')}
							value={selectedStatistic ? selectedStatistic.mobilePrepaid : 0}
							icon={<StayCurrentPortrait />}
							gradient={'error'}
						/>
						<ServiceCard
							text={translate('numbers.mobile-postpaid')}
							value={selectedStatistic ? selectedStatistic.mobilePostpaid : 0}
							icon={<StayCurrentPortrait />}
							gradient={'support1'}
						/>
						<ServiceCard
							text={translate('numbers.internet')}
							value={selectedStatistic ? selectedStatistic.internet : 0}
							icon={<Cast />}
							gradient={'primary'}
						/>
						<ServiceCard
							text={translate('fixed.services')}
							value={selectedStatistic ? selectedStatistic.fix : 0}
							icon={<Phone />}
							gradient={'success'}
						/>
					</GridContainer>
				</GridItem>
			)}
		/>
	);
};

export default memo(ActiveServices);
